module.exports = __webpack_public_path__ + "static/media/python.9a12ab11.svg";